import styled from 'styled-components'
import { rem } from 'polished'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import LineArrowUpIcon from 'LuxKit/Icons/line/LineArrowUpIcon'

const CTA_BUTTON_SIZE = 40
const CTA_BUTTON_EXPANDED_WIDTH = 88
const CTA_BUTTON_BORDER_RADIUS = 20
const CTA_TRANSITION_DURATION = '0.2s'
const CTA_TRANSITION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)'

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  background-color: ${props => props.theme.palette.neutral.default.one};
  color: ${props => props.theme.palette.neutral.default.eight};
  font-family: ${props => props.theme.font.primary.family};
  font-size: ${rem(14)};
  white-space: nowrap;
  overflow: hidden;

  transition:
    width ${CTA_TRANSITION_DURATION} ${CTA_TRANSITION_EASING},
    padding ${CTA_TRANSITION_DURATION} ${CTA_TRANSITION_EASING},
    border-radius ${CTA_TRANSITION_DURATION} ${CTA_TRANSITION_EASING};

  width: ${rem(CTA_BUTTON_SIZE)};
  height: ${rem(CTA_BUTTON_SIZE)};
  padding: 0;
  border-radius: 50%;

  &.expanded {
    width: ${rem(CTA_BUTTON_EXPANDED_WIDTH)};
    border-radius: ${rem(CTA_BUTTON_BORDER_RADIUS)};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`

const StyledLabel = styled.span`
  overflow: hidden;
  transition:
    opacity 0.15s ease,
    width ${CTA_TRANSITION_DURATION} ${CTA_TRANSITION_EASING},
    margin ${CTA_TRANSITION_DURATION} ${CTA_TRANSITION_EASING};

  opacity: 0;
  width: 0;
  margin-right: 0;

  .expanded & {
    opacity: 1;
    width: auto;
    margin-right: ${rem(4)};
  }
`

interface Props {
  expanded: boolean
  onClick: () => void
  disabled?: boolean
  label?: string
}

function MorphingSendButton({ expanded, onClick, disabled = false, label }: Props) {
  const intl = useIntl()
  const resolvedLabel = label ?? intl.formatMessage({
    id: 'BS48E9kPZqX7zQKNgOPY',
    defaultMessage: 'Send',
    description: 'Default label for the send button in the trip planner chat',
  })
  return (
    <StyledButton
      type="button"
      className={clsx({ expanded })}
      onClick={onClick}
      disabled={disabled}
    >
      <StyledLabel>{resolvedLabel}</StyledLabel>
      <LineArrowUpIcon />
    </StyledButton>
  )
}

export default MorphingSendButton
